import {gql} from '@apollo/client/core';

export const ShippingMethodFragment = gql`
  fragment shippingMethod on ShippingMethod {
    id
    carrier
    carrier_title
    carrier_logo
    method
    price
    label
    description
    title
    priceDescription
    dontDeliverDates
    showCustomDatePicker
    showWhereToLeavePackage
    fastestDeliveryDate
  }
`;

export const CustomerProfileAddressFragment = gql`
  fragment customerProfileAddress on CustomerProfileAddress {
    address
    addressCity
    addressZip
    companyName
    country
    countryCode
    ean
    fullname
    phone
  }
`;

export const RedirectObjectFragment = gql`
  fragment redirectObject on RedirectObject {
    order {
      couponCode
      deliveryDate
      deliveryMessage
      deliveryMethod
      webOrderId
      id
      lineItems {
        id
        itemType
        productId
        quantity
        sku
      }
      orderNumber
      placed
      signedUpForNewsletter
      status
      ticketsSent
      total
      groupVoucherCode
    }
    redirectUrl
  }
`;



